let textBanner = {};

textBanner.init = function () {
  let textBannerShowChar;

  if (matchMedia('screen and (max-width: 1023px)').matches) {
    textBannerShowChar = 150;
  } else {
    textBannerShowChar = 350;
  }

  // let textBannerEllipsisText = '...';
  let textBannerSection = $('.js-text-intro-block');

  $.each(textBannerSection, function () {
    let currentTextBanner = $(this);
    let textBannerMoreText = currentTextBanner.data('readmore');
    let textBannerLessText = currentTextBanner.data('readless');
    let textBannerMobile = currentTextBanner.find('.js-text-intro-block-content');
    let contentWrapper = currentTextBanner.find('.js-content');

    let content = currentTextBanner.find('.js-content').html();
    if (content && content.length > textBannerShowChar) {
      currentTextBanner.addClass('has-content-hidden');
      let textBannerShownContent = content.substr(0, textBannerShowChar);

      let htmlLess = '<div class="less">' + textBannerShownContent + '</div>';
      let htmlMore = '<div class="more">' + content + '</div>';
      let readButton = '&nbsp;&nbsp;<a href="#" class="js-readMore-link readMore-link">' + textBannerMoreText + '</a>';
      currentTextBanner.find('.js-content').html(htmlLess);
      currentTextBanner.find('.js-content').append(htmlMore);
      currentTextBanner.find('.js-content').append(readButton);
    } else {
      currentTextBanner.find('.js-arrow-mobile').addClass('d-none');
    }

    currentTextBanner.find('.js-readMore-link').click(function () {
      if (contentWrapper.hasClass('toggle-content')) {
        textBannerMobile.removeClass('toggle-content');
        contentWrapper.removeClass('toggle-content');
        $(this).html(textBannerMoreText);
      } else {
        textBannerMobile.addClass('toggle-content');
        contentWrapper.addClass('toggle-content');
        $(this).html(textBannerLessText);
      }
    });

    textBannerMobile.click(function () {
      if (matchMedia('screen and (max-width: 1023.98px)').matches) {
        if (contentWrapper.hasClass('toggle-content')) {
          textBannerMobile.removeClass('toggle-content');
          contentWrapper.removeClass('toggle-content');
        } else {
          textBannerMobile.addClass('toggle-content');
          contentWrapper.addClass('toggle-content');
        }
      }
    });
  });
}

textBanner.init();



// WEBPACK FOOTER //
// ./scripts/components/text-banner.js